module.exports = __webpack_public_path__ + "img/burger-hero.09439502.png";